import React, { useEffect, useState } from 'react';
import './FooterData.scss';

interface FooterProps {
  styles?: boolean;
}

const Footer: React.FC<FooterProps> = ({ styles = false }) => {
  const [footerStyle, setFooterStyle] = useState<React.CSSProperties>({});

  const footerContainerStyle: React.CSSProperties = {
    position: 'relative',
    width: '100%',
    backgroundColor: 'white',
    color: 'black',
    textAlign: 'center',
    clear: 'both',
    fontSize: '14px',
  };

  useEffect(() => {
    const handleResize = () => {
      const viewportHeight = window.innerHeight;
      const contentHeight = document.body.scrollHeight;

      if (contentHeight <= viewportHeight) {
        setFooterStyle({
          position: 'fixed',
          bottom: '0',
          width: '100%',
          backgroundColor: 'white',
          color: 'black',
          textAlign: 'center',
          marginBottom: '5px',
        });
      } else {
        setFooterStyle({
          position: 'relative',
          width: '100%',
          backgroundColor: 'white',
          color: 'black',
          textAlign: 'center',
          marginBottom: '5px',
        });
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
      <div style={styles ? { ...footerContainerStyle, ...footerStyle } : {}}>
        <div className="text-center footer-text">
          <p>This is a government computer system.</p>
          <p>
            Unauthorized access, use, misuse, or modification of this computer
            system or of the data contained herein or in transit to/from this
            system constitutes a violation of Title 18, United States Code,
            Section 1030, and may subject the individual to Criminal and Civil
            penalties pursuant to Title 26, United States Code, Sections 7213(A),
            7213A (the Taxpayer Browsing Protection Act), 7431 and Health
            Insurance Portability and Accountability Act of 1996. If monitoring
            reveals possible evidence of criminal activity, such evidence may be
            provided to Law Enforcement Personnel. Additional information may be
            found at the Nebraska DHHS System Website Disclaimer under
            'Disclaimer'.
          </p>
        </div>
        <div className="footer">Copyright © NE-DHHS 2025</div>
      </div>
  );
}

export default Footer;